import { Pipe, PipeTransform } from '@angular/core';
import { WorkOrderStatus } from '../../model/index';


@Pipe({ name: 'workOrderStatus' })
export class WorkOrderStatusPipe implements PipeTransform {

    transform(value: WorkOrderStatus): any {
        if (!value) {
            return '';
        }
        return `<div class="sm-status-badge work-order-status-${value.toLocaleLowerCase()}">
                    <span class="material-symbols-outlined sm-status-badge-icon">square</span> ${value}
                </div>`;
    }
}